// extracted by mini-css-extract-plugin
module.exports = {"container":"SayveParticipationManual_container__v3RzA"};